module.exports = __webpack_public_path__ + "static/img/product2-3.696eb0f5.png";